// @ts-check
import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import TextInput from '../form/TextInput';

/**
 * @typedef Props
 * @property {string} searchText
 * @property {(searchText: string) => void} onChange
 * @property {import('react-intl').intlShape} intl
 *
 * @extends {React.Component<Props>}
 */
class DataBrowserSearch extends React.Component {
    render() {
        const { searchText, onChange, intl } = this.props;

        return (
            <div className="data-browser__search">
                <TextInput
                    value={searchText}
                    placeholder={intl.formatMessage({ id: 'variablePicker.searchForVariables' })}
                    onChange={onChange}
                    showClearIcon
                    clearIcon="close"
                />
                {searchText && <div className="data-browser__search__divider" />}
                <div className="data-browser__search-icon">
                    <i className="material-symbols" aria-label="Search icon">
                        search
                    </i>
                </div>
            </div>
        );
    }
}

DataBrowserSearch.propTypes = {
    searchText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

DataBrowserSearch.defaultProps = {
    searchText: '',
};

export default injectIntl(DataBrowserSearch);
